// PRODUCTION API'S
export const ADMIN_API = process.env.REACT_APP_ADMIN_API
export const PAYMENT_API = process.env.REACT_APP_PAYMENT_API

export const SHAREABLE_QUIZ_URL = process.env.REACT_APP_SHAREABLE_QUIZ_URL
export const WHATSAPP_API_URL = process.env.REACT_APP_WHATSAPP_API
export const PAYMENT_LINK_API_URL = process.env.REACT_APP_PAYMENT_LINK_URL
